<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Živali</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
          <pridelovalec :pridelovalec="pridelovalec"  shema="EKO PRI" :sezona="dataSezona.sezona">
          </pridelovalec>
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                    
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                        
                         :row-render="rowRenderFunction"
                      
                        

                         
                        
                                               >
                 <template v-slot:ukaznigumbi="{props}">
                  <ukaznigumbiknt :data-item="props.dataItem"   :editDisabled="editDisabled"
                    @edit="edit"
                    @save="saveItem" 
                    @remove="removeItem"
                    @cancel="cancel"/>

                    </template>


                    <template v-slot:sifrantDDCell="{props}">

                      <sifkulturaddcell :data-item="props.dataItem" 
                        :field="props.field"
                        :sifrantData="sifrant['zival']"
                        :sifrantTree="sifrantTree"
                     
                        @change="(e) => sifrantZivalChange(e, props.dataItem)"
                        />

                    </template>

                <template v-slot:status="{props}">
                      <ddcell 
                        :data-item="props.dataItem" 
                        :field="props.field"
                        :sifrantData="sifrant['statuspridelka']"
                        :selectedValue="{id:props.dataItem.statuspridelkaid,naziv:props.dataItem.statuspridelkanaziv}"
                        @change="(e) => statusChange(e, props.dataItem)"
                   />
                    </template>
                     <template v-slot:enotakolicinedd="{props}">
                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"
                        :sifrantData="sifrant['enotakolicine']"
                        :selectedValue="{id:props.dataItem.merskaenotakolicineid,naziv:props.dataItem.merskaenotanaziv}"
                        @change="(e) => sifrantEnoteChange(e, props.dataItem)"
                   />
                    </template>

                    <template v-slot:vrsta="{props}">
                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"

                        :sifrantData="vrste"
                        :selectedValue="{id:props.dataItem.vrstapridelkaid,naziv:props.dataItem.vrstapridelkanaziv}"
                        @change="(e) => vrstaChange(e, props.dataItem)"
                   />
                    </template>

                   

                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                       
                        <button title="Dodaj" :disabled="editDisabled"
                                class="k-button k-primary"
                                @click="vstavi">
                                Dodaj žival
                        </button>
                      
                        
                           <!--  <button :disabled="editDisabled"
                                title="Prenesi iz prejšnje sezone"
                                class="k-button k-primary"
                               @click="dodajIzPrejsnjeSezone"
                            >
                                Prenesi iz prejšnje sezone
                            </button>

                          -->
                             <button :disabled="editDisabled"
                                title="Shrani kulturo"
                                class="k-button k-primary"
                                @click="shraniProizvode"
                            >
                                Shrani
                            </button>
                            

                                  <button class="k-button k-primary"  title="Nazaj" @click="nazaj" >Nazaj</button>
                                  <div>
                            
                            <input type="text" v-model="seznamProizvodov" placeholder="Živali" name="seznam-proizvodov" id="seznam-proizvodov" class="k-textbox" />
                            <button title="Dodaj živali" :disabled="editDisabled"
                                class="k-button k-primary"
                                @click="uvozi">
                                Dodaj seznam živali
                        </button>
                        <button title="Izvozi" :disabled="editDisabled"
                                class="k-button k-primary"
                                @click="exportExcel">
                               Izvozi v excel
                        </button>
                            </div>
                       </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
import SifrantZivaliDownCell from './support/SifrantZivaliDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
import { process } from '@progress/kendo-data-query';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import moment from 'moment'





export default {
  components:{
      'ukaznigumbiknt': StatusCommandCell,
      'dropdownlist':DropDownList,
      'ddcell': StatusDownCell,
      'sifkulturaddcell': SifrantZivaliDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'pridelovalec':PridelovalecKratko
  },
  props:['sezona','pridelovalecid'],
    data () {
        return {
            vrste:[
            {id:0,naziv:"rastline"},
            {id:1,naziv:"živali"},
            {id:2,naziv:"alge"},
            {id:3,naziv:"proizvodi"},
            {id:4,naziv:"krma"},
            {id:5,naziv:"vino"},
            {id:6,naziv:"ostalo"}
            ],
            sifrantTree:{},
            dataLoading:false,
            seznamProizvodov:"",
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
                 //{ field: "naziv", title:"Proizvod",cell:'sifrantddcell',width: "330px",footerCell: this.nogaNazivVsot},
                 //{ field: "naziv_interno", title:"Kultura",width: "250px"},
                 { field: "naziv", title:"Žival (nac. šifrant)",width: "260px",cell:'sifrantDDCell',footerCell: this.nogaNazivVsot},
                 { field: "certifikat", title:"Certifikat",width: "150px", editable:false}, 

                 { field: "stevilo", title:"Število",type: "number",editor: 'numeric', footerCell: this.nogaVsotaStevila,width: "150px",format: '{0:n0}',validation: { required: true}},
                { field: "vsotagvz", title:"Vsota GVŽ",type: "number",editor: 'numeric', editable:false, footerCell: this.nogaVsotaGvz,width: "150px",format: '{0:n3}',validation: { required: true} },     //{ field: "vsotagvz", title:"Vsota GVŽ",type: "number",editor: 'numeric', editable:false, footerCell: this.nogaVsotaGvz,width: "150px",format: '{0:n3}',validation: { required: true} },
                
                //{ field: "veljavnostcertifikataod", title:"Datum določitve statusa", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true},cell:this.formatDate},
         
             //   { field: "vrsta", title:"Vrsta",width: "220px",cell:'vrsta'},
                { field: "statuspridelkanaziv", title:"Status",width: "160px",cell:'status'},
                { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            ],
          

           

        }
    },
      computed: {
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.proizvod.proizvod;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
      
           },
    created () {

 if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};
this.naloziPodatke();

      
    },
  


    methods: {
      ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        ...mapActions('proizvod', ['load','save','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('proizvod',['update',"add","remove","makeEditable",'replace']),
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
         nogaVsotaPovrsine: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.povrsina?current.povrsina:0):0, 0),"n2")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
              formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
            //error handle za prazen šifrnat!!!!
        naloziPodatke: function(){
          this.dataLoading=true;

        this.replace([]);
        this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(()=>{

        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"zival"}).then(()=>{
              this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"enotakolicine"}).then(()=>{
                  this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"statuspridelka"}).then(()=>
          {

             let sifrant=this.sifrant["zival"];  
            var vrsteKulture = [];


        var sifrantData=sifrant.reduce((a,i)=>{
          
          let vk=a.find(e=>e.id==i.idvrstazivali*1000000);
          if(!vk){
            vk={id:i.idvrstazivali*1000000,naziv:i.vrstazivali,skupine:[]}
            a.push(vk);
          }

          let sk=vk.skupine.find(e=>e.id==i.idskupinazivali*1000);
          if(!sk){
            sk={id:i.idskupinazivali*1000,naziv:i.skupinazivali,zivali:[]}
            vk.skupine.push(sk);
          }
          
          let k=sk.zivali.find(e=>e.id==i.id);
          if(!k){
            sk.zivali.push(i)
          }
          

            return a;

        },[]);
        console.log(sifrantData);

        console.log("sifrantZivali");
        console.log(sifrant);

        //datasource 1x
       this.sifrantTree=new kendo.data.HierarchicalDataSource({
          data:sifrantData, 
          schema: {
            model: {
             children: {
               schema: { data:"skupine", model: {children: 'zivali'}}
             }   
          }
        }
        });




            this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"zival"}).then(

          data=>{this.dataLoading=false;},


          error=>{console.log("tukaj sem!!!");this.dataLoading=false;});
        
      
           

            });

          });
              });
/*
        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"proizvod"}).then(()=>{
            this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"statuspridelka"}).then(()=>{
                this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"enotakolicine"}).then(()=>{
            let sifrant=this.sifrant["proizvod"];  
            var vrsteProizvodov = [];


        var sifrantData=sifrant.reduce((a,i)=>{
          
          let vk=a.find(e=>e.id==i.idvrstaproizvoda);
          if(!vk){
            vk={id:i.idvrstaproizvoda,naziv:i.vrstaproizvoda,skupine:[]}
            a.push(vk);
          }

          let sk=vk.skupine.find(e=>e.id==i.idskupinaproizvoda);
          if(!sk){
            sk={id:i.idskupinaproizvoda,naziv:i.skupinaproizvoda,proizvodi:[]}
            vk.skupine.push(sk);
          }
          
          let k=sk.proizvodi.find(e=>e.id==i.id);
          if(!k){
            sk.proizvodi.push(i)
          }
          

            return a;

        },[]);

       
        console.log(sifrant);

        //datasource 1x
       this.sifrantTree=new kendo.data.HierarchicalDataSource({
          data:sifrantData, 
          schema: {
            model: {
             children: {
               schema: { data:"skupine", model: {children: 'proizvodi'}}
             }   
          }
        }
        });

        this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled}).then(

          data=>{this.dataLoading=false;},


          error=>{console.log("tukaj sem!!!");this.dataLoading=false;});
        
      
            });
          });
        });
        */
      })
        },
        sifranProizvodChange: function(sifrant,dataItem) {

          
          

          if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["naziv"])
              dataItem.oldValues["naziv"] =dataItem["naziv"];

            if(!dataItem.oldValues["proizvodid"])
              dataItem.oldValues["proizvodid"] =dataItem["proizvodid"];

              Vue.set( dataItem, 'naziv',sifrant.naziv);
              Vue.set( dataItem, 'proizvodid',sifrant.id);
              Vue.set( dataItem, 'merskaenotanaziv',this.sifrant['proizvod'].find(i=>i.id==sifrant.id).enota);
              Vue.set( dataItem, 'merskaenotakolicineid',this.sifrant['proizvod'].find(i=>i.id==sifrant.id).enotakolicineid);

            //  Vue.set( dataItem, 'vsotagvz',(dataItem.stevilo?dataItem.stevilo:0)*this.sifrant['proizvod'].find(s=>s.id==dataItem.proizvodid).gvz);
     
        },
         sifrantZivalChange: function(sifrant,dataItem) {

          
          

          if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["naziv"])
              dataItem.oldValues["naziv"] =dataItem["naziv"];

            if(!dataItem.oldValues["zivalid"])
              dataItem.oldValues["zivalid"] =dataItem["zivalid"];

            //certifikat in enota
            if(!dataItem.oldValues["certifikat"])
              dataItem.oldValues["certifikat"] =dataItem["certifikat"];

            if(!dataItem.oldValues["vsotagvz"])
              dataItem.oldValues["vsotagvz"] =dataItem["stevilo"]*this.sifrant["zival"].find(i=>i.id==sifrant.id).gvz;


              Vue.set( dataItem, 'naziv',sifrant.naziv);
              Vue.set( dataItem, 'zivalid',sifrant.id);
             Vue.set( dataItem, 'certifikat',this.sifrant["zival"].find(i=>i.id==sifrant.id).certifikat);
             Vue.set( dataItem, 'kategorija',this.sifrant["zival"].find(i=>i.id==sifrant.id).kategorija);
            Vue.set( dataItem, 'vsotagvz',dataItem["stevilo"]*this.sifrant["zival"].find(i=>i.id==sifrant.id).gvz)
             
     
        },
        statusChange: function(e, dataItem) {

             if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["statuspridelkanaziv"])
              dataItem.oldValues["statuspridelkanaziv"] =dataItem["statuspridelkanaziv"];

            if(!dataItem.oldValues["statuspridelkaid"])
              dataItem.oldValues["statuspridelkaid"] =dataItem["statuspridelkaid"];

            Vue.set( dataItem, 'statuspridelkanaziv',e.value.naziv);
              Vue.set( dataItem, 'statuspridelkaid',e.value.id);
            
    
        },
        vrstaChange: function(e, dataItem) {

             if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstapridelkanaziv"])
              dataItem.oldValues["vrstapridelkanaziv"] =dataItem["vrstapridelkanaziv"];

            if(!dataItem.oldValues["vrstapridelkaid"])
              dataItem.oldValues["vrstapridelkaid"] =dataItem["vrstapridelkaid"];

            Vue.set( dataItem, 'vrstapridelkanaziv',e.value.naziv);
              Vue.set( dataItem, 'vrstapridelkaid',e.value.id);
            
    
        },
         sifrantEnoteChange: function(e, dataItem) {

             if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["merskaenotanaziv"])
              dataItem.oldValues["merskaenotanaziv"] =dataItem["merskaenotanaziv"];

            if(!dataItem.oldValues["merskaenotakolicineid"])
              dataItem.oldValues["merskaenotakolicineid"] =dataItem["merskaenotakolicineid"];

            Vue.set( dataItem, 'merskaenotanaziv',e.value.naziv);
              Vue.set( dataItem, 'merskaenotakolicineid',e.value.id);
            
       //     dataItem["statuspridelkanaziv"] = e.value.naziv;
         //   dataItem["statuspridelkaid"] = e.value.id;
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

           if(e.field=="stevilo")
              Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['zival'].find(s=>s.id==e.dataItem.zivalid).gvz);  

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         uvozi() {
            var proizvodi=this.seznamProizvodov.split(";");

            for (const  proizvod of proizvodi) {
              if(!proizvod.trim())
                  continue;
            const dataItem = { inEdit: true,jeaktivna:1,
                 // veljavnostcertifikatado:new Date(this.dataSezona.sezona*1+1,11,31),veljavnostcertifikataod:new Date(),
                  statuspridelkaid:2,statuspridelkanaziv:this.sifrant["statuspridelka"].find(i=>i.id==2).naziv,
                  naziv:proizvod.trim(),
                  //vrstapridelkanaziv:"rastline",
                   naziv:proizvod.trim(),
                  zivalid:this.sifrant["zival"].find(i=>i.naziv.indexOf(proizvod.trim())>=0)?this.sifrant["zival"].find(i=>i.naziv.indexOf(proizvod.trim())>=0).id:-1,
                  certifikat:this.sifrant["zival"].find(i=>i.naziv.indexOf(proizvod.trim())>=0)?this.sifrant["zival"].find(i=>i.naziv.indexOf(proizvod.trim())>=0).certifikat:"",
                  kategorija:this.sifrant["zival"].find(i=>i.naziv.indexOf(proizvod.trim())>=0)?this.sifrant["zival"].find(i=>i.naziv.indexOf(proizvod.trim())>=0).kategorija:"",
                  pridelovalecid:this.pridelovalecid,
                  sezona:this.dataSezona.sezona, 

                  //proizvodid:this.sifrant["proizvod"][0].id,
                  //merskaenotakolicineid:this.sifrant["enotakolicine"].find(i=>i.naziv.indexOf("kilogram")>=0).id,
                  //merskaenotanaziv:this.sifrant["enotakolicine"].find(i=>i.naziv.indexOf("kilogram")>=0).naziv
                   };
            this.add(dataItem);
            }
        },
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  statuspridelkaid:2,statuspridelkanaziv:this.sifrant["statuspridelka"].find(i=>i.id==2).naziv,
                  //naziv:"",
                  //vrstapridelkanaziv:"rastline",
                  //vrstapridelkaid:0,
                  naziv:this.sifrant["zival"].find(i=>i.naziv.indexOf("govedo nad dve leti")>=0).naziv,
                  zivalid:this.sifrant["zival"].find(i=>i.naziv.indexOf("govedo nad dve leti")>=0).id,
                  certifikat:this.sifrant["zival"].find(i=>i.naziv.indexOf("govedo nad dve leti")>=0).certifikat ,
                  kategorija:this.sifrant["zival"].find(i=>i.naziv.indexOf("govedo nad dve leti")>=0).kategorija ,
                  pridelovalecid:this.pridelovalecid,
                  sezona:this.dataSezona.sezona, 
                  //proizvodid:this.sifrant["proizvod"][0].id,
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec._id;
             this.$router.push({ name: 'zival', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id} });
             this.pridelovalec.sezona=this.sezona;
             this.naloziPodatke();
//              });



        },
         exportExcel () {
            this.saveExcel({
                data: this.gridData,
                fileName: this.pridelovalecid+"_KULTURE",
                columns: this.columns
            });
        },
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        shraniProizvode () {
              this.save();
    },
       
        
    }
};
</script>

